class TabCarousel extends HTMLElement {
  constructor() {
    super();
    this.initSlide();
    this.elementToFocus = this.querySelector('button');
  }

  get container() {
    return this.querySelector('.swiper');
  }

  get sliderPagination() {
    return this.querySelector('.swiper-pagination');
  }

  get sliderNavigation() {
    return this.querySelector('.swiper-navigation');
  }

  get columns() {
    return parseInt(this.dataset.columns);
  }

  get columnsMobile() {
    return parseInt(this.dataset.columnsMobile);
  }

  get spaceBetween() {
    return parseInt(this.dataset.spaceBetween);
  }

  initSlide() {
    const slider = new FoxTheme.Carousel(this.container, {
      loop: false,
      spaceBetween: this.spaceBetween,
      slidesPerView: this.columnsMobile,
      slidesPerGroup: this.columnsMobile,
      focusableElements: 'input, select, option, textarea, button, video, label, a',
      pagination: {
        el: this.sliderPagination,
        clickable: true,
      },
      ...(this.sliderNavigation && { 
        navigation: { 
          nextEl: this.sliderNavigation.querySelector('.swiper-button-next'), 
          prevEl: this.sliderNavigation.querySelector('.swiper-button-prev') 
        } 
      }),
      breakpoints: {
        768: {
          slidesPerView: this.columns,
          slidesPerGroup: this.columns,
        },
      },
      allowTouchMove: true,
    });


    slider.init();
    const focusableElements = FoxTheme.a11y.getFocusableElements(this);

    focusableElements.forEach((element) => {
      element.addEventListener('focusin', function () {
        const slide = element.closest('.swiper-slide');
        slide && slider.slider.slideTo(slider.slider.slides.indexOf(slide));
      });
    });
  }
}

customElements.define('tab-carousel', TabCarousel);
